import React from "react";
// local imports
import { Bottom, Middle, Top } from "components";

const Navbar = () => {
  return (
    <>
      <Top />
      <Middle />
      <Bottom />
    </>
  );
};

export default Navbar;
